// extracted by mini-css-extract-plugin
export default {"send_btn_wrapper":"sendMessage_send_btn_wrapper__WcRPw","send_icon":"sendMessage_send_icon__79B8f","active_icon":"sendMessage_active_icon__yybaV"};